<template>
    <div>
        <category-form
            :is-catagory-form-sidebar-active.sync="isCatagoryFormSidebarActive"
            :category-data="categoryData"
            @refetch-data="refetchCategoryData" 
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                            variant="primary"
                            @click="updateCategory()"
                         
                            >
                                <span class="text-nowrap">Add Category</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <b-table
                v-if="!foodCategories.length"
                :items="foodCategories"
                responsive
                :fields="tableColumns"
                show-empty
                empty-text="No matching records found"
                class="position-relative"
            >
            </b-table>
            <table v-else class="table table-striped">
                <thead>
                    <tr>
                    <th scope="col" v-for="(col, index) in tableColumns" :key="index">
                        {{col.label}}
                    </th>
                    </tr>
                </thead>
                <draggable v-model="foodCategories" tag="tbody" hadle=".handle" @change="updateRoomsOrdering()">
                    <tr v-for="(item, index) in foodCategories" :key="index">
                        <th scope="row" class="pl-2">
                            <feather-icon size="24" icon="MenuIcon"/> 
                        </th>
                        <td class="pl-2">
                            <span>{{ item.title[currentLocale] }}</span>
                        </td>
                        <td class="pl-2">
                            <span v-html="(item.slug[currentLocale])"></span>
                        </td>
                        <td class="pl-2">
                            <b-badge
                                pill
                                :variant="`light-${resolveCatagoryStatusVariant(item.is_active)}`"
                                class="text-capitalize"
                            >
                                {{ resolveCatagoryStatusnameVariant(item.is_active) }} 
                            </b-badge>
                        </td>
                        <td class="pl-2">
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateCategory(item)" variant="outline-success">Edit</b-button>
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                        </td>
                    </tr>
                </draggable>
            </table>
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalFoodCategories"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
    import {
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox
    } from 'bootstrap-vue';
    import draggable from 'vuedraggable'
    import { ref,onUnmounted } from '@vue/composition-api'
    import store from '@/store'
    import Ripple from 'vue-ripple-directive';
    import useCategoryList from './useCategoryList';
    import CategoryForm from './CategoryForm.vue'
    import foodStoreModule from '../foodStoreModule'
    import { MenuIcon } from 'vue-feather-icons'

    export default {

        components: {
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
            BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox,
            CategoryForm, draggable, MenuIcon,
        },
        directives: {
            'b-modal': VBModal,
            Ripple
        },
        computed: {
            currentLocale() {
                return  this.$i18n.locale;
            },
           
        },
        setup() {
            const CAT_STORE_MODULE_NAME = 'app-food';
            if (!store.hasModule(CAT_STORE_MODULE_NAME)) store.registerModule(CAT_STORE_MODULE_NAME, foodStoreModule)
            onUnmounted(() => {
                if (store.hasModule(CAT_STORE_MODULE_NAME)) store.unregisterModule(CAT_STORE_MODULE_NAME)
            });

            const {
                isCatagoryFormSidebarActive,
                categoryData,
                refetchCategoryData,
                tableColumns,
                getCategoryData,
                searchQuery,
                fetchCategoryData,
                sortBy,
                // isSortDirDesc,
                foodCategories,
                totalFoodCategories,
                refCatagoryListTable,
                resolveCatagoryStatusVariant,
                resolveCatagoryStatusnameVariant,
                updateCategory,
                deleteData,
                isSortDirDesc,
                dataMeta,
                perPage,
                currentPage,
            } = useCategoryList();

            fetchCategoryData();

            return {
                isCatagoryFormSidebarActive,
                categoryData,
                refetchCategoryData,
                tableColumns,
                getCategoryData,
                searchQuery,
                fetchCategoryData,
                sortBy,
                // isSortDirDesc,
                foodCategories,
                totalFoodCategories,
                refCatagoryListTable,
                resolveCatagoryStatusVariant,
                resolveCatagoryStatusnameVariant,
                updateCategory,
                deleteData,
                isSortDirDesc,
                dataMeta,
                perPage,
                currentPage,
            }
        },
        methods:{
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm('Please confirm that you want to delete Food Category ID.'+id, {
                        title: 'Please Confirm',
                        size: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        cancelVariant: 'outline-secondary',
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then(value => {
                        if(value === true){
                        this.deleteData(id)
                    }
                })
            },
            onDragEnd(evt) {
                // You can save new order here
                console.log('New order:', this.foodCategories.map(c => c.id));
                // Optionally send to API
            },
            onDragMove(evt) {
                return true; // or add custom logic to allow/reject
            }
        }
    }
</script>